import type { ReactNode } from "react";
import type { Integration } from "scantling-common";
import { DateDisplay } from "./components.js";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

interface IntegrationHoverCardProps {
  integration: Integration;
  children: ReactNode;
}

export function IntegrationHoverCard({
  integration,
  children,
}: IntegrationHoverCardProps) {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent className="w-72" align="start">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm font-medium">
              {integration.slug}
            </span>
            <Badge variant={integration.enabled ? "default" : "secondary"}>
              {integration.enabled ? "Enabled" : "Disabled"}
            </Badge>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>{integration.type}</span>
          </div>
          <Separator />
          <div className="flex flex-col gap-1.5 text-xs">
            {integration.niceName && (
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Name</span>
                <span>{integration.niceName}</span>
              </div>
            )}
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Created</span>
              <DateDisplay value={integration.createdAt} />
            </div>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
